import { render, staticRenderFns } from "./investmentClues6.vue?vue&type=template&id=2b3a9d5e&"
import script from "./investmentClues6.vue?vue&type=script&lang=js&"
export * from "./investmentClues6.vue?vue&type=script&lang=js&"
import style0 from "./investmentClues6.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports